import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const moTradeCompetitionApi = {
  getCompetitionInfo(gameId) {
    return http.get(API_URLS.MO_COMPETITION_INFO, {
      query: {gameId},
    });
  },
  /**
   *
   * @param params {competitionId,teamFlag,channel,scene}
   * @returns {Promise | Promise<unknown>}
   */
  joinCompetition(params) {
    return http.post(API_URLS.MO_COMPETITION_JOIN, {params});
  },
  getMyCompetitionInfo(gameId) {
    return http.get(API_URLS.MO_COMPETITION_SELF, {
      // rankGroup: 排序规则组，G_TRADE:trade volume, G_ROI:ROI.获得当前用户,roi 与 trade volume 的排名.
      // 需求改PNL改为ROI
      query: {gameId, rankGroup: ['G_TRADE', 'G_ROI'], needRank: true},
    });
  },
  getMyROICompetitionInfo(gameId) {
    return http.get(API_URLS.MO_COMPETITION_SELF, {
      // rankGroup: 排序规则组，G_TRADE:trade volume, G_ROI:ROI.获得当前用户,roi 与 trade volume 的排名.
      // 需求改PNL改为ROI
      query: {gameId, rankGroup: ['G_ROI'], needRank: true},
    });
  },
  getMyCompetitionTradeInfo(gameId) {
    return http.get(API_URLS.MO_COMPETITION_SELF, {
      query: {gameId, rankGroup: ['G_TRADE'], needRank: true},
    });
  },
  getTradeVolumeRankList(gameId) {
    return http.get(API_URLS.MO_COMPETITION_RANK, {
      // group: 排序规则组，G_TRADE:trade volume 的排名
      query: {gameId, group: 'G_TRADE'},
    });
  },
  getPNLRankList(gameId) {
    return http.get(API_URLS.MO_COMPETITION_RANK, {
      // group: 排序规则组，G_ROI:ROI 的排名
      // 需求改PNL改为ROI
      query: {gameId, group: 'G_ROI'},
    });
  },
};
